
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const CART_RESET = "CART_RESET";

export const INCREASE_CART_QUANTITY = "INCREASE_CART_QUANTITY";
export const DECREASE_CART_QUANTITY = "DECREASE_CART_QUANTITY";
